import { createSlice } from "@reduxjs/toolkit";

import { getBannerSlider, addBannerSlider, updateBannerSlider, deleteBannerSlider } from "./thunk";

export const initialState = {
    bannerSlider: {
        content: []
    },
    loading: false,
    error: null as any,
};

const BannerSlider = createSlice({
    name: 'BannerSlider',
    initialState,
    reducers: {},
    extraReducers: (builder) => {

        builder.addCase(getBannerSlider.pending, (state: any) => {
            state.loading = true;
        });
        builder.addCase(getBannerSlider.fulfilled, (state: any, action: any) => {
            state.loading = false;
            state.bannerSlider = action.payload;
        });
        builder.addCase(getBannerSlider.rejected, (state: any, action: any) => {
            state.loading = false;
            state.error = action.payload || null;
        });

        builder.addCase(addBannerSlider.pending, (state: any) => {
            state.loading = true;
        });
        builder.addCase(addBannerSlider.fulfilled, (state: any, action: any) => {
            state.loading = false;
            state.bannerSlider.content.unshift(action.payload);
        });
        builder.addCase(addBannerSlider.rejected, (state: any, action: any) => {
            state.loading = false;
            state.error = action.payload || null;
        });

        builder.addCase(updateBannerSlider.pending, (state: any) => {
            state.loading = true;
        });
        builder.addCase(updateBannerSlider.fulfilled, (state: any, action: any) => {
            state.loading = false;
            state.bannerSlider.content = state.bannerSlider.content.map((banner: any) =>
                banner.id === action.payload.id
                    ? { ...banner, ...action.payload }
                    : banner
            );
        });
        builder.addCase(updateBannerSlider.rejected, (state: any, action: any) => {
            state.loading = false;
            state.error = action.payload || null;
        });

        builder.addCase(deleteBannerSlider.pending, (state: any) => {
            state.loading = true;
        });
        builder.addCase(deleteBannerSlider.fulfilled, (state: any, action: any) => {
            state.loading = false;
            state.bannerSlider.content = state.bannerSlider.content.filter(
                (bannerSlider: any) => bannerSlider.id !== action.payload
            );
        });
        builder.addCase(deleteBannerSlider.rejected, (state: any, action: any) => {
            state.loading = false;
            state.error = action.payload || null;
        });
    }
});

export default BannerSlider.reducer;
